import { YM_COUNTER_CLIENT_ID, ROISTAT_VISIT_ID } from 'application/services/AnalyticsService';

import { useAuthLeadUtmMarksMutation, UtmMarkKeyType } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

import AuthUtils, { PROMOCODE_COOKIE_NAME, SBER_AGENT_ID_COOKIE_NAME } from './utils';
import { UseUTMMarksType } from './types';

const useUtmMarks = (): UseUTMMarksType => {
  const [mutation] = useAuthLeadUtmMarksMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async () => {
    const utmMarks = [];

    const ymClientId = localStorage.getItem(YM_COUNTER_CLIENT_ID);
    const roistatVisitId = localStorage.getItem(ROISTAT_VISIT_ID);

    if (ymClientId) {
      utmMarks.push({ key: UtmMarkKeyType.YmId, value: ymClientId });
      localStorage.remove(YM_COUNTER_CLIENT_ID);
    }

    if (roistatVisitId) {
      utmMarks.push({ key: UtmMarkKeyType.Roistat, value: roistatVisitId });
      localStorage.remove(ROISTAT_VISIT_ID);
    }

    const promocodeCookieValue = AuthUtils.getCookieByKey(PROMOCODE_COOKIE_NAME);

    if (promocodeCookieValue) {
      utmMarks.push({ key: UtmMarkKeyType.Promocode, value: promocodeCookieValue });
    }

    const sberAgentIdCookieValue = AuthUtils.getCookieByKey(SBER_AGENT_ID_COOKIE_NAME);

    if (sberAgentIdCookieValue) {
      utmMarks.push({ key: UtmMarkKeyType.SberAgentId, value: sberAgentIdCookieValue });
    }

    const mutationResult = await mutation({
      variables: { input: { utmMarks } },
    });

    return !!mutationResult.data?.utmMarksSendToAmoLead?.ok;
  };

  return [request];
};

export default useUtmMarks;
